module.exports = __webpack_public_path__ + "img/hkstp.796ef5f2.png";